export const cleanAddress = (addressLine: string): string => {
  return addressLine
    .split(',')
    .filter((word) => !!word.trim())
    .join(',');
};
